<template>
  <div>
    <v-container fluid class="hyp-table-container">
      <v-row>
        <v-col cols="6">
          <v-btn
            color="primary"
            outlined
            small
            class="mr-3"
            @click="handleClickNew"
            >Create new alert</v-btn
          >
        </v-col>
        <v-col cols="6">
          <v-btn
            color="primary"
            outlined
            small
            class="mr-3 pull-right"
            title="Click here to access legacy Alerts"
            @click="handleClickOpenLegacyAlerts"
            >Legacy Alerts</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-2">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="col-2">
          <v-select
            v-model="filterType"
            :items="filterTypes"
            item-text="text"
            item-value="value"
            label="Filter type"
            return-object
            hide-details
            multiple
            clearable
          >
            <template v-slot:selection="{ index }">
              <span v-if="index === 0"> {{ filterType.length }} selected </span>
            </template>
          </v-select>
        </v-col>
        <v-col class="col-2">
          <v-select
            v-model="filterFrequency"
            :items="filterFrequencies"
            item-text="text"
            item-value="value"
            label="Filter frequency"
            return-object
            hide-details
            multiple
            clearable
          >
            <template v-slot:selection="{ index }">
              <span v-if="index === 0">
                {{ filterFrequency.length }} selected
              </span>
            </template>
          </v-select>
        </v-col>
        <v-col class="col-2">
          <v-select
            v-model="filterShared"
            :items="filterShareds"
            item-text="text"
            item-value="value"
            label="Filter shared with"
            return-object
            hide-details
            multiple
            clearable
          >
            <template v-slot:selection="{ index }">
              <span v-if="index === 0">
                {{ filterShared.length }} selected
              </span>
            </template>
          </v-select>
        </v-col>
        <v-col class="col-2">
          <v-select
            v-model="filterEnabled"
            :items="filterEnableds"
            item-text="text"
            item-value="value"
            label="Filter status"
            return-object
            hide-details
            multiple
            clearable
          >
            <template v-slot:selection="{ index }">
              <span v-if="index === 0">
                {{ filterEnabled.length }} selected
              </span>
            </template>
          </v-select>
        </v-col>
        <v-col class="col-2">
          <v-select
            v-model="filterDelivery"
            :items="filterDeliveries"
            item-text="text"
            item-value="value"
            label="Filter delivery"
            return-object
            hide-details
            multiple
            clearable
          >
            <template v-slot:item="{ item }">
              {{ item.text }}
            </template>
            <template v-slot:selection="{ index }">
              <span v-if="index === 0">
                {{ filterDelivery.length }} selected
              </span>
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="hyp-data-table-container">
          <v-data-table
            v-resize="this.handleResize"
            :headers="headers"
            hide-default-footer
            :items="items"
            :items-per-page="itemsPerPage"
            :search="search"
            item-key="id"
            sort-by="name"
            :height="heightNotificationListing"
            fixed-header
            :loading="loading"
            loading-text="Retreiving alerts"
            class="notification-data-table"
          >
            <template v-slot:item.formatted.docTypeName="{ item }">
              <div>{{ item.formatted.docTypeName }}</div>
            </template>
            <template v-slot:item.formatted.name="{ item }">
              <div>
                <div class="flair-text">
                  {{ getFlairText(item) }}
                </div>
                {{ item.formatted.name }}
              </div>
            </template>
            <template v-slot:item.formatted.enabled="{ item }">
              <div v-if="item.formatted.frequency">
                <v-switch
                  v-model="item.formatted.enabled"
                  @change="handleChangeStatus(item)"
                  :title="item.formatted.enabled ? 'Enabled' : 'Disabled'"
                  :disabled="!canEdit(item)"
                ></v-switch>
              </div>
            </template>
            <template v-slot:item.formatted.frequency="{ item }">
              <div class="hyp-table-td-first-letter">
                {{ item.formatted.frequency }}
              </div>
              <div
                v-if="item.formatted.scheduleInfo"
                class="hyp-table-td-first-letter"
              >
                {{ item.formatted.scheduleInfo }}
              </div>
            </template>
            <template v-slot:item.formatted.delivery="{ item }">
              <v-icon
                v-if="item.formatted.useEmail"
                size="20"
                title="Email"
                class="mr-2"
                >far fa-envelope</v-icon
              >
              <v-icon
                v-if="item.formatted.usePush"
                size="20"
                title="Push"
                class="mr-2"
                >far fa-comment-dots</v-icon
              >
              <span
                v-if="
                  item.formatted.useIntegrations &&
                  item.formatted.targetsArr &&
                  item.formatted.targetsArr.length
                "
              >
                <span
                  v-for="target in getUniqueTargets(item)"
                  :key="target.targetId"
                >
                  <span v-if="target.icon">
                    <v-icon size="20" class="mr-2" :title="target.display">{{
                      target.icon
                    }}</v-icon>
                  </span>
                  <span
                    v-if="!target.icon && target.targetType"
                    class="mr-2 target-no-icon"
                    :title="target.display"
                  >
                    {{ target.targetType.toUpperCase() }}
                  </span>
                </span>
              </span>
            </template>
            <template v-slot:item.formatted.lastUpdateTime="{ item }">
              <div class="hyp-table-td-datetime">
                {{ item.formatted.lastUpdateTime }}
              </div>
            </template>
            <template v-slot:item.formatted.expirationDate="{ item }">
              <div v-html="getExpiration(item)"></div>
            </template>
            <template v-slot:item.formatted.isShared="{ item }">
              <div v-if="item.formatted.frequency && item.formatted.isOwner">
                <PopupInfo
                  v-if="item.formatted.sharedList.length"
                  :text="item.formatted.sharedInfo"
                  :text-display="getSharedInfo(item)"
                ></PopupInfo>
                <span v-if="!item.formatted.sharedInfo">NO</span>
              </div>
              <div v-if="item.formatted.frequency && !item.formatted.isOwner">
                N/A
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu open-on-click offset-x offset-y left rounded="lg">
                <template v-slot:activator="{ on: menu }">
                  <v-icon
                    v-on="menu"
                    class="pull-right mr-2 mt-1 hyp-options-icon"
                    size="20"
                    >fas fa-ellipsis-v</v-icon
                  >
                </template>

                <v-list>
                  <v-list-item
                    v-if="canEdit(item)"
                    @click="handleClickEdit(item)"
                  >
                    <v-list-item-title>
                      <v-icon size="16" class="mr-1" :disabled="!canEdit(item)"
                        >fas fa-edit</v-icon
                      >
                      Edit Alert
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="!item.formatted.isOwner"
                    :disabled="!isViewEnabled(item)"
                    @click="handleClickView(item)"
                  >
                    <v-list-item-title>
                      <v-icon
                        size="16"
                        class="mr-1"
                        :disabled="!isViewEnabled(item)"
                        >fas fa-file-invoice</v-icon
                      >
                      View Alert
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="!isSavedSearch(item)"
                    :disabled="!isCopyDeleteEnabled(item)"
                    @click="handleClickCopy(item)"
                  >
                    <v-list-item-title>
                      <v-icon
                        size="16"
                        class="mr-1"
                        :disabled="!isCopyDeleteEnabled(item)"
                        >fas fa-copy</v-icon
                      >
                      Copy Alert
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    :disabled="!isCopyDeleteEnabled(item)"
                    @click="handleClickDelete(item)"
                  >
                    <v-list-item-title>
                      <v-icon
                        size="16"
                        class="mr-1"
                        :disabled="!isCopyDeleteEnabled(item)"
                        >fas fa-trash</v-icon
                      >
                      Delete Alert
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="item.docType === 'saved-search'"
                    @click="handleClickSavedSearchResults(item)"
                  >
                    <v-list-item-title>
                      <v-icon size="16" class="mr-1">fas fa-list</v-icon>
                      Go to Results
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-slot:no-data>
              <div class="my-5">
                You currently have no alerts set up. <br /><br />
                You can either create a new Tripwire alert or <br />
                create a new search alert by clicking the <br />
                Create New Alert button above.
              </div>
            </template>
            <template v-slot:no-results>
              <div class="my-5">
                Your search returned no results.
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <ConfirmationPopup
      :show="confirmShow"
      :title="confirmTitle"
      :text="confirmText"
      :buttonCancel="confirmBtnCancel"
      :buttonAction="confirmBtnAction"
      :max-width="500"
      :message="deleteAlertMessage"
    ></ConfirmationPopup>
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashOrderBy from "lodash/orderBy";
import lodashRemove from "lodash/remove";
import lodashSortedUniqBy from "lodash/sortedUniqBy";
import dayjs from "dayjs";

import { nowUtc } from "@/common/date.utilities";
import {
  MODULE_PREFIX_HOME,
  MODULE_PREFIX_NOTIFICATIONS,
  MODULE_PREFIX_SAVED_SEARCH,
  MODULE_PREFIX_ALERTS,
} from "@/store";
import {
  GET_MODAL,
  GET_SELECTOR_PANEL,
  GET_NOTIFICATION,
  GET_NEW_NOTIFICATION,
  GET_SAVED_SEARCH_QUERIES,
  GET_SAVED_SEARCH_DETAILS,
  CLOSE_ALERT_WIZARD,
} from "@/store/actions.type";
import { mapGetters } from "vuex";
import {
  getNotifications,
  deleteNotification,
  updateNotification,
} from "@/services/notifications/notifications.service";
import {
  NOTIFICATION_FREQUENCY_OPTIONS,
  NOTIFICATION_DOC_TYPES,
  NOTIFICATION_TYPE_SAVED_SEARCH,
  NOTIFICATION_GLOBAL_SEARCHES_OWNER,
} from "@/common/constants/notifications";
import {
  EVENT_ACTIONS,
  ALERTSV2_CATEGORIES,
} from "@/common/constants/analytics";
import { hasEssentialsAccess } from "@/services/user/user.service";
import { TARGETS_TYPES } from "@/common/constants/targets";

export default {
  name: "NotificationsTable",
  components: {
    ConfirmationPopup: () => import("@/components/common/ConfirmationPopup"),
    PopupInfo: () => import("@/components/common/PopupInfo"),
  },
  props: {},
  data: function () {
    let docTypes = lodashCloneDeep(NOTIFICATION_DOC_TYPES);
    docTypes = lodashOrderBy(docTypes, ["text"]);

    if (hasEssentialsAccess()) {
      docTypes = lodashRemove(docTypes, (t) => {
        return t.value !== "pulse";
      });
    }
    if (!this.featureUnlocked("assets-management-alerts")) {
      docTypes = lodashRemove(docTypes, (t) => {
        return !t.value.toLowerCase().includes("asset");
      });
    }

    let frequencies = lodashCloneDeep(NOTIFICATION_FREQUENCY_OPTIONS);
    frequencies = frequencies.map((item) => {
      return {
        text: item.display,
        value: item.adverb,
      };
    });

    let deliveries = lodashCloneDeep(TARGETS_TYPES);
    deliveries = deliveries.map((item) => {
      return {
        text: item.display,
        value: item.targetType,
        icon: item.icon ? item.icon : null,
      };
    });
    deliveries.unshift({
      text: "Push",
      value: "push",
      icon: "far fa-comment-dots",
    });
    deliveries.unshift({
      text: "Email",
      value: "email",
      icon: "far fa-envelope",
    });

    return {
      loading: false,
      filterType: [],
      filterTypes: docTypes,
      filterFrequency: [],
      filterFrequencies: frequencies,
      filterShared: [],
      filterShareds: [
        { text: "Shared", value: true },
        { text: "Not shared", value: false },
      ],
      filterEnabled: [],
      filterEnableds: [
        { text: "Enabled", value: true },
        { text: "Disabled", value: false },
      ],
      filterDelivery: [],
      filterDeliveries: deliveries,
      headers: [
        {
          text: "Type",
          value: "formatted.docTypeName",
          sortable: true,
          width: 150,
        },
        { text: "Name", value: "formatted.name", sortable: true, width: 175 },
        { text: "Enabled", value: "formatted.enabled", sortable: true },
        { text: "Frequency", value: "formatted.frequency", sortable: true },
        {
          text: "Delivery",
          value: "formatted.delivery",
          sortable: false,
          width: 125,
        },
        {
          text: "Last Modified",
          value: "formatted.lastUpdateTime",
          sortable: true,
        },
        {
          text: "Expiration",
          value: "formatted.expirationDate",
          sortable: true,
        },
        { text: "Shared With", value: "formatted.isShared", sortable: true },
        { text: "", value: "actions", sortable: false },
      ],
      items: [],
      itemsPerPage: 10000,
      search: null,
      confirmShow: false,
      itemSelected: null,
      showPopupDetails: false,
      menu: false,
      deleteAlertMessage: null,
      windowSize: {
        x: 0,
        y: 0,
      },
    };
  },
  async mounted() {
    await this.getNotifications();
  },
  computed: {
    ...mapGetters({
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
      modal: MODULE_PREFIX_NOTIFICATIONS + "modal",
      notification: MODULE_PREFIX_NOTIFICATIONS + "notification",
      savedSearchDetails: MODULE_PREFIX_SAVED_SEARCH + "savedSearchDetails",
    }),
    typeSelectedDisplay() {
      let display = null;
      if (lodashGet(this.itemSelected, "formatted.docTypeName")) {
        display = this.itemSelected.formatted.docTypeName;
      }
      return display;
    },
    confirmTitle() {
      return `Delete ${this.typeSelectedDisplay}`;
    },
    confirmText() {
      const sharedMessage = lodashGet(this.itemSelected, "sharedList")
        ? "This alert will be deleted for all shared members."
        : "";

      return lodashGet(this.itemSelected, "formatted.name")
        ? `Are you sure you want to delete the ${this.typeSelectedDisplay} named: <span class="application-heading">${this.itemSelected.formatted.name}</span>? ${sharedMessage}`
        : null;
    },
    confirmBtnCancel() {
      return {
        text: "Cancel",
        onClickFnc: async () => {
          this.deleteAlertMessage = null;
          this.confirmShow = false;
          this.itemSelected = null;
          this.resetModalDelete(false);
        },
      };
    },
    confirmBtnAction() {
      return {
        text: "Delete",
        loader: this.loading,
        onClickFnc: async () => {
          this.loading = true;
          let success = false;
          if (this.itemSelected.formatted.isOwner) {
            const item = lodashCloneDeep(this.itemSelected);
            item.formatted = this.itemSelected.formatted || {};
            item.formatted.enabled = false;
            item.formatted.sharedList = [];
            item.formatted.frequency = null;
            item.formatted.expiration = null;
            item.formatted.expirationDate = null;
            item.formatted.useIntegrations = false;
            item.formatted.useEmail = false;
            item.formatted.usePush = false;
            item.formatted.schedule = null;
            success = await updateNotification(item);
          } else success = await deleteNotification(this.itemSelected);
          this.loading = false;
          if (success) {
            this.deleteAlertMessage = null;
            this.confirmShow = false;
            await this.getNotifications();
            this.updateSavedSearchQueries();
            this.resetModalDelete(true);
          } else {
            this.deleteAlertMessage = "There was an issue deleting";
          }
        },
      };
    },
    heightNotificationListing() {
      return this.windowSize.y - 270;
    },
  },
  methods: {
    handleResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    async getNotifications() {
      this.loading = true;
      this.items = await getNotifications({
        search: this.search,
        type:
          this.filterType && this.filterType.length ? this.filterType : null,
        frequency:
          this.filterFrequency && this.filterFrequency.length
            ? this.filterFrequency
            : null,
        shared:
          this.filterShared && this.filterShared.length
            ? this.filterShared
            : null,
        enabled:
          this.filterEnabled && this.filterEnabled.length
            ? this.filterEnabled
            : null,
        delivery:
          this.filterDelivery && this.filterDelivery.length
            ? this.filterDelivery
            : null,
        notificationsOnly: true,
      });
      this.loading = false;
    },
    openModal(type = null, readOnly = false, commsOnly = false) {
      const modal = lodashCloneDeep(this.modal);
      modal.visible = true;
      modal.type = type;
      modal.readOnly = readOnly;
      modal.commsOnly = commsOnly;
      this.$store.dispatch(MODULE_PREFIX_NOTIFICATIONS + GET_MODAL, modal);
    },
    resetModalDelete(close) {
      const modal = lodashCloneDeep(this.modal);
      modal.delete = false;
      if (close) {
        modal.visible = false;
      }
      this.$store.dispatch(MODULE_PREFIX_NOTIFICATIONS + GET_MODAL, modal);
    },
    async handleClickNew() {
      await this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NEW_NOTIFICATION
      );
      this.openModal();
      this.handlePageTrackerEvent(
        ALERTSV2_CATEGORIES.alertsv2,
        EVENT_ACTIONS.clicked,
        "Create New Alert Button"
      );
    },
    handleClickOpenLegacyAlerts() {
      this.$store.dispatch(MODULE_PREFIX_ALERTS + CLOSE_ALERT_WIZARD, {});

      this.selectorPanel.selected = "alerts";
      this.selectorPanel.visible = true;
      this.$store.dispatch(
        MODULE_PREFIX_HOME + GET_SELECTOR_PANEL,
        this.selectorPanel
      );
    },
    handleClickCopy(item) {
      const notification = lodashCloneDeep(item);
      delete notification.search_notification_id;
      delete notification.formatted.id;
      notification.name = notification.formatted.name = `Copy of ${notification.formatted.name}`;
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        notification
      );
      this.openModal(notification.formatted.docType, false);
    },
    handleClickEdit(item) {
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        item
      );
      const commsOnly =
        item.formatted.docType === NOTIFICATION_TYPE_SAVED_SEARCH;
      this.openModal(item.formatted.docType, false, commsOnly);
    },
    handleClickView(item) {
      this.$store.dispatch(
        MODULE_PREFIX_NOTIFICATIONS + GET_NOTIFICATION,
        item
      );
      const commsOnly =
        item.formatted.docType === NOTIFICATION_TYPE_SAVED_SEARCH &&
        item.ownerId !== item.userId;
      this.openModal(item.formatted.docType, true, commsOnly);
    },
    async handleClickDelete(item) {
      if (item) {
        this.itemSelected = item;
        this.confirmShow = true;
      }
    },
    handleClickSavedSearchResults(item) {
      const selectorPanel = {};
      selectorPanel.selected = "search";
      selectorPanel.visible = true;
      selectorPanel.selectedData = {};
      if (item.ownerId === NOTIFICATION_GLOBAL_SEARCHES_OWNER) {
        selectorPanel.selectedData.libraryParams = item.params;
      } else if (lodashGet(item, "formatted.id")) {
        selectorPanel.selectedData.savedSearchId = item.formatted.id;
      }

      this.$store.dispatch(
        MODULE_PREFIX_HOME + GET_SELECTOR_PANEL,
        selectorPanel
      );
    },
    async handleChangeStatus(item) {
      await updateNotification(item);
      await this.getNotifications();
      this.updateSavedSearchQueries();
    },
    updateSavedSearchQueries() {
      this.$store.dispatch(
        MODULE_PREFIX_SAVED_SEARCH + GET_SAVED_SEARCH_QUERIES,
        {}
      );

      // refresh the selected saved search on the search panel
      if (this.savedSearchDetails) {
        const savedSearch = lodashCloneDeep(this.savedSearchDetails);
        savedSearch.refresh = new Date().toISOString();
        this.$store.dispatch(
          MODULE_PREFIX_SAVED_SEARCH + GET_SAVED_SEARCH_DETAILS,
          savedSearch
        );
      }
    },
    getExpiration(item) {
      let expirationText = "";
      if (lodashGet(item, "formatted.frequency")) {
        expirationText = "Does not expire";
        if (lodashGet(item, "formatted.expirationDate")) {
          expirationText = item.formatted.expirationDate;
          if (dayjs(nowUtc()).isAfter(item.formatted.expirationDate)) {
            expirationText += `<br/><span class="red--text">Expired</span>`;
          }
        }
      }
      return expirationText;
    },
    getUniqueTargets(item) {
      return lodashSortedUniqBy(
        item.formatted.targetsArr,
        (target) => target.targetType
      );
    },
    getSharedInfo(item) {
      return `YES (${item.formatted.sharedList.length})`;
    },
    getFlairText(item) {
      if (!item.formatted.isOwner) {
        return item.ownerId === NOTIFICATION_GLOBAL_SEARCHES_OWNER
          ? "[SEARCH LIBRARY]"
          : "[SHARED]";
      }
      return "";
    },
    isSavedSearch(item) {
      return (
        lodashGet(item, "formatted.docType") === NOTIFICATION_TYPE_SAVED_SEARCH
      );
    },
    isViewEnabled(item) {
      return (
        !lodashGet(item, "formatted.isOwner") &&
        (lodashGet(item, "formatted.docType") !==
          NOTIFICATION_TYPE_SAVED_SEARCH ||
          lodashGet(item, "formatted.docType") ===
            NOTIFICATION_TYPE_SAVED_SEARCH)
      );
    },
    isCopyDeleteEnabled(item) {
      return (
        lodashGet(item, "formatted.docType") !==
          NOTIFICATION_TYPE_SAVED_SEARCH ||
        lodashGet(item, "formatted.docType") === NOTIFICATION_TYPE_SAVED_SEARCH
      );
    },
    canEdit(item) {
      return (
        item.formatted.isOwner ||
        item.ownerId === NOTIFICATION_GLOBAL_SEARCHES_OWNER
      );
    },
  },
  watch: {
    async filterType() {
      await this.getNotifications();
    },
    async filterFrequency() {
      await this.getNotifications();
    },
    async filterShared() {
      await this.getNotifications();
    },
    async filterEnabled() {
      await this.getNotifications();
    },
    async filterDelivery() {
      await this.getNotifications();
    },
    modal: {
      async handler() {
        if (lodashGet(this.modal, "delete") && this.notification) {
          await this.handleClickDelete(this.notification);
          return;
        }
        if (!lodashGet(this.modal, "visible")) {
          await this.getNotifications();
          this.updateSavedSearchQueries();
        }
      },
      deep: true,
    },
    "selectorPanel.selected": {
      async handler() {
        if (
          lodashGet(this.selectorPanel, "selected") === "notifications" &&
          lodashGet(this.selectorPanel, "visible")
        ) {
          // refreshing the table when user opens the slideout in case a
          // notification was changed since last time slideout was opened
          await this.getNotifications();
        }
      },
    },
  },
};
</script>

<style>
.notification-data-table .v-data-table-header__icon {
  position: relative;
  top: -2px;
  left: 7px;
}
</style>

<style scoped lang="scss">
.hyp-table-container {
  width: 1200px;
}
.hyp-table-td-name {
  width: 150px;
}
.hyp-table-td-datetime {
  width: 110px;
}
.hyp-table-td-first-letter::first-letter {
  text-transform: uppercase;
}
.notification-data-table {
  overflow-y: auto;
}
.flair-text {
  font-size: 0.85em;
  color: $primary-color;
}
.target-no-icon {
  font-size: 0.85em;
}
</style>
